/**
 * Notifications carry a `link` string chosen by the backend, such as "student/classes/12" or "messages/7".
 * This turns one into a real route for the person's role. Unknown links fall back to their home page,
 * so a notification can never send someone to a broken screen.
 */
import { homeFor } from '../core/session.js';

export function resolveLink(link, role) {
  const raw = String(link || '').replace(/^\/+/, '');
  const home = homeFor(role);
  if (!raw) return home;
  const parts = raw.split('/');
  const [head, second, third] = parts;

  if (head === 'messages') return second ? `/${role}/messages?c=${encodeURIComponent(second)}` : `/${role}/messages`;
  if (head === 'network') return `/${role}/network${second ? `?tab=${encodeURIComponent(second)}` : ''}`;
  if (head === 'admin') {
    const map = { matching: 'requirements', batches: 'batches', safety: 'safety' };
    return `/admin/${map[second] || second || 'overview'}`;
  }

  // Links written for the student/freelancer/company areas: re-home them under the viewer's own role.
  if (['student', 'professional', 'company', 'startup'].includes(head)) {
    const area = head === role ? head : role;
    if (second === 'batches') return `/${area}/coaching`;
    if (second === 'cofounders') return `/${area}/cofounder`;
    if (second === 'applications' && area === 'company') return '/company/requirements';
    if (second === 'classes' && third) return `/${area}/classes/${third}`;
    return `/${area}/${parts.slice(1).join('/')}`.replace(/\/$/, '');
  }
  return home;
}
